export default __webpack_public_path__ + "static/media/apple-download.f31c38ad.svg";